import {colors} from "../enum/colors";
import {validateAddressLine1, validateBirthYear, validateCardNumber, validateCity, validatePhoneNumber, validatePhoneType, validatePostalCode, validateProvince} from "../common/validation";
import {removeLoaderAnimation, scrollToElement} from "../common/util";
import {getTraduction, traductionEnum} from "../common/traduction";
import {pushEventNewsletterSubscribe} from "../common/cybermetrie";
import {CYBERMETRIE_EVENT_VALUES} from "../constants/constants";
import MouseUpEvent = JQuery.MouseUpEvent;
import TriggeredEvent = JQuery.TriggeredEvent;

const textPlaceholder = 'text-container-placeholder';

$(() => {
    if ($("#contact-details-form").length) {
        bindContactDetailsInputs();
        removeLoaderAnimation($('.page-container'));
    }

    $("#contact-details-form").on("submit", function (event) {
        return validateContactDetailsStep(CYBERMETRIE_EVENT_VALUES.NEWSLETTER_ORIGIN_CREATION);
    });
})

$(document).ajaxComplete(function () {
    if ($("#contact-sign-up-form").length) {
        bindContactDetailsInputs();
    }
});

export function validateCardNumberStep(isInModal: boolean) {
    let cardNumberIsValid = validateCardNumber();

    if (cardNumberIsValid) {
        return true;
    } else {
        let $firstError = $("label.input-error input").first()
        if (!isInModal) {
            scrollToElement($firstError, -120, true)
        }
        $firstError.focus();
        return false;
    }
}


// @ts-ignore
export function validatePostalCodeStep(isInModal: boolean) {
    let postalCodeIsValid = validatePostalCode();

    if (postalCodeIsValid) {
        return true;
    } else {
        let $firstError = $("label.input-error input").first()
        if (!isInModal) {
            scrollToElement($firstError, -120, true)
        }
        $firstError.focus()
    }
}

export function validateContactDetailsStep(origin: string) {
    let addressLine1IsValid = validateAddressLine1();
    let phoneNumber = $(".telephone-contact");
    let phoneNumberIsValid = validatePhoneNumber(phoneNumber);
    let postalCodeIsValid = validatePostalCode();
    let birthYearIsValid = validateBirthYear();
    let cityIsValid = validateCity();
    let provinceIsValid = validateProvince();
    let phoneTypeIsValid = validatePhoneType();

    if (addressLine1IsValid && phoneNumberIsValid && postalCodeIsValid && birthYearIsValid && cityIsValid && provinceIsValid && phoneTypeIsValid) {
        // check if newsletter exists
        pushEventIfNewsletterCheckboxIsChecked(origin);
        return true;
    } else {
        if ((addressLine1IsValid && phoneNumberIsValid && postalCodeIsValid && birthYearIsValid && cityIsValid) && (!provinceIsValid || !phoneTypeIsValid)) {
            let $firstError = $("label.input-error").first()
            scrollToElement($firstError, -120, true);
            return false;
        }

        let $firstError = $("label.input-error");

        if ($firstError.first().hasClass('select-container')) {
            $firstError = $firstError.first();
        } else {
            $firstError = $firstError.first().find('input')
        }

        scrollToElement($firstError, -120, true)
        return false;

    }
}

export function bindCardNumberInputs() {

    let $cardNumber = $(".card-number");
    $cardNumber.mask('00000-000000000-0');
    $cardNumber.on("input", function () {
        const cardNumber = $(this).val();
        cardNumber ? $cardNumber.prev().addClass(textPlaceholder)
            : $cardNumber.prev().removeClass(textPlaceholder);
    });

}

export function bindContactDetailsInputs() {
    let $address = $(".address-contact");
    handleFocusOnInput($address);

    let $addressOptional = $(".address-optional-contact");
    handleFocusOnInput($addressOptional);

    let $cityContact = $(".city-contact");
    handleFocusOnInput($cityContact);

    bindPostalCodeInput();

    let $telephone = $(".telephone-contact");
    $telephone.mask('000-000-0000')
    handleFocusOnInput($telephone);

    let $telephoneOther = $(".telephone-contact-other");
    $telephoneOther.mask('000-000-0000')
    handleFocusOnInput($telephoneOther);

    let $birth = $(".birth-contact");
    $birth.mask('0000');
    handleFocusOnInput($birth);

    let provinceContactId = "#province-contact";
    handleDropDown(provinceContactId, getTraduction(traductionEnum.PROVINCE_PLACEHOLDER));
    handleOption(provinceContactId);

    preselectProvince();
    preselectPhoneType();

    let telephoneTypeContactId = "#telephone-type-contact";
    handleDropDown(telephoneTypeContactId, getTraduction(traductionEnum.PHONE_TYPE_PLACEHOLDER));
    handleOption(telephoneTypeContactId);

    function handleDropDown($element: any, placeholder: string) {
        if (!$($element).hasClass("disabled")) {
            let $select = $($element + " > .select");
            const placeholderText = $select.find('>p:first-child').text();
            if (placeholderText && placeholderText !== placeholder) {
                addPlaceholderToSelect($($element).find('>p:first-child'), placeholder);
            }

            $select.parent().on("keypress", (event) => {
                if (event.key === 'Enter') {
                    toggleOptions(event, $element, colors.white);
                }
            });
            $select.on("click", (event) => {
                toggleOptions(event, $element, colors.white);
            });
        }
    }

    function handleOption($element: any) {
        let $option = $($element + " .option");
        if ($option.length > 0) {
            $option.each(function () {
                const $this = $(this);
                let $inputOption = $this.find('> input');
                $inputOption.on('keyup', function (event) {
                    if (event.key === 'Enter') {
                        $inputOption.trigger('click');
                    }
                }).on('keydown', function (event) {
                    // This prevents the keydown to be called
                    if (event.key === 'Enter') {
                        event?.preventDefault();
                    }
                });
                $inputOption.on('keydown', function (event) {
                    if (event.key === 'Escape') {
                        toggleOptions(event, $element, colors.white);
                    }
                });
            })
        }
    }

    /* Clicking outside select-containers closes them */
    $(document).on('mouseup', function (e) {
        let containerTelephoneType = '#telephone-type-contact';
        let contactProvince = '#province-contact';
        closeOnClickOutside(e, $(containerTelephoneType), containerTelephoneType);
        closeOnClickOutside(e, $(contactProvince), contactProvince);
    });

    /* Card input section */
    let $help = $('#card > #icon-rounded-help2');
    let $tooltip = $('#card > .card-tooltip');
    let $close = $('#card > #icon-close-small');

    if (!$help.hasClass('active') && !$close.hasClass('active')) {
        $help.addClass('active');
    }

    $('#card > svg').on("click", function (event) {
        if ($('#card').hasClass('disabled')) return;
        if ($help.hasClass('active')) {
            $help.removeClass('active');
            $tooltip.css('display', "block");
            $help.css('display', "none");
            $close.css('display', "block");
        } else {
            $help.addClass('active');
            $close.css('display', "none");
            $tooltip.css('display', "none");
            $help.css('display', "block");
        }
    });

    /* input select listeners */
    $("#telephone-type-contact .option input").on("click", function (event) {
        setInputText(event, '#telephone-type-contact', '#contactDetails-types-hidden', colors.white);
        addPlaceholderToSelect($('#telephone-type-contact > p'), getTraduction(traductionEnum.PHONE_TYPE_PLACEHOLDER));
    });
    $("#province-contact .option input").on("click", function (event) {
        setInputText(event, '#province-contact', '#contactDetails-province-hidden', colors.white);
        addPlaceholderToSelect($('#province-contact > p'), getTraduction(traductionEnum.PROVINCE_PLACEHOLDER));
    });
}

function preselectProvince() {
    let hiddenProvinceValue = $('#contactDetails-province-hidden').val();
    if (hiddenProvinceValue) {

        // retrieve values from select
        let values = $('input[name="province-contact"]');
        values.each(function () {
            if (hiddenProvinceValue === $(this).val()) {
                $('#province-contact > .select > p').text(<string>$(this).attr('aria-label'));
                $('label[id=province-contact]').children().first().addClass('select-container-placeholder').text(getTraduction(traductionEnum.PROVINCE_PLACEHOLDER));
                return;
            }
        });
    }
}

function preselectPhoneType() {
    let hiddenPhoneType = $('#contactDetails-types-hidden').val();
    if (hiddenPhoneType) {
        // retrieve values from select
        let values = $('input[name="telephone-type-contact"]');
        values.each(function () {
            if (hiddenPhoneType === $(this).val()) {
                $('#telephone-type-contact > .select > p').text(<string>$(this).attr('aria-label'));
                $('label[id=telephone-type-contact]').children().first().addClass('select-container-placeholder').text(getTraduction(traductionEnum.PHONE_TYPE_PLACEHOLDER));
                return;
            }
        });
    }
}

export function bindPreselectHistory() {
    /* Clicking outside select-containers closes them */
    $(document).on('mouseup', function (e) {
        let preselectHistory = '#select-history-timeframe';
        closeOnClickOutside(e, $(preselectHistory), preselectHistory);
    });

    $("#select-history-timeframe .option input").on("click", function (event) {
        setInputText(event, '#select-history-timeframe', '#select-history-timeframe-hidden', colors.white);
        $('#select-history-timeframe-hidden').trigger('change');
    });
}

export function addPlaceholderToSelect($element: JQuery<HTMLElement>, placeholder: string) {
    $element.text(placeholder);
    $element.addClass('select-container-placeholder');
}

export function bindPostalCodeInput() {
    let $postalCode = $('.postal-code-contact');
    $postalCode.mask('S0S 0S0');
    handleFocusOnInput($postalCode);
}

function handleFocusOnInput($element: JQuery<HTMLElement>) {
    $element.on("input", function () {
        $element.val() ? $element.prev().addClass(textPlaceholder)
            : $element.prev().removeClass(textPlaceholder);
    });
    $element.on("focus", function () {
        $element.prev().addClass(textPlaceholder);
    });
    $element.on("focusout", function () {
        $element.val() ? $element.prev().addClass(textPlaceholder)
            : $element.prev().removeClass(textPlaceholder);
    });
    $element.trigger("input");
}

function isDisabled(event: TriggeredEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, inputId: string) {
    if ($(inputId).hasClass('disabled')) {
        /* stop label from triggering child inputs*/
        event?.stopPropagation();
        event?.preventDefault();
        return true;
    }
    return false;
}

function changeSelectColor(event: TriggeredEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, inputId: string, color: string) {
    if (isDisabled(event, inputId)) return;
    $(inputId + ' >.select').css('background-color', color);
}

export function toggleOptions(event: TriggeredEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, inputId: string, optionBackgroundColor: colors) {
    if (isDisabled(event, inputId)) return;

    let element = $(inputId + '>.select svg');
    let expended = $(inputId + ' .select').attr('aria-expanded');
    if (expended === 'true') {
        $(inputId + ' >.select-options').css('display', 'none');
        element.removeClass("active");
        $(inputId + ' >.select').attr("aria-expanded", "false");
        changeSelectColor(event, inputId, colors.white);

    } else {
        element.addClass("active");
        $(inputId + ' >.select-options').css('display', 'block');
        $(inputId + ' >.select').attr("aria-expanded", "true");
        changeSelectColor(event, inputId, optionBackgroundColor);
    }

    /* stop label from triggering child inputs*/
    event?.stopPropagation();
    event?.preventDefault();
}

function setInputText(event: TriggeredEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, inputId: string, hiddenInputId: string, optionBackgroundColor: colors) {
    let $inputChecked = $(inputId + ' input:checked');
    if ($inputChecked.length === 1) {
        $($inputChecked[0]).prop('checked', false);
    }
    let value = $inputChecked.val()?.toString();
    let radioValue = $inputChecked.prev().text();

    if (radioValue && value !== undefined) {
        $(hiddenInputId).val(value);
        $(inputId + ' >.select >p').text(radioValue);
        toggleOptions(event, inputId, optionBackgroundColor);
    }
    closeOptions();
}

function closeOptions() {
    let element = $(".select svg");
    if (element.hasClass("active")) {
        $('.select-options').css('display', 'none');
        element.removeClass("active");
        $(".select").attr("aria-expanded", "false");
    }
}

function closeOnClickOutside(e: MouseUpEvent, container: JQuery<HTMLElement>, inputId: string) {
    if (!container.is(e.target as any) && container.has(e.target as any).length === 0) {
        let element = $(inputId + "> .select svg");

        if (element.hasClass("active")) {
            $(inputId + '> .select-options').css('display', 'none');
            element.removeClass("active");
            $(inputId + " > .select").attr("aria-expanded", "false");
            $(inputId + ' >.select').css('background-color', 'white');
        }
    }
}

function pushEventIfNewsletterCheckboxIsChecked(origin: string) {
    let $newsletterCheckbox = $('#consentToComm1');

    if ($newsletterCheckbox.length) {
        if ($newsletterCheckbox.prop('checked')) {
            pushEventNewsletterSubscribe(origin, CYBERMETRIE_EVENT_VALUES.NEWSLETTER_NAME_MOI)
        }
    }
}